// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__VN_Er","label":"styles_label__B5AUA","icon":"styles_icon__Am3Ff"};